import type {
  BillingConfig,
  Invoice,
  InvoiceAddressBlock,
  PaymentTermsDetails,
} from "./types";

export const INVOICE_FROM: InvoiceAddressBlock = {
  name: "Universal Software",
  lines: [
    "4, Ramya, Polytechnic Road, Opp Ketav",
    "Petrol Pump, H Colony, Ambawadi,",
    "Ahmedabad, Gujarat, 380015, India",
  ],
  gstin: "24AAAFU9641B1ZF",
};

export const DEFAULT_PAYMENT_TERMS: PaymentTermsDetails = {
  dueDays: 15,
  bank: {
    bankName: "AXIS BANK LIMITED",
    accountName: "Universal Software",
    accountNumber: "003010200046729",
    branchName: "Ahmedabad Main - Law Garden",
    ifscCode: "UTIB0000003",
  },
};

export const INVOICES: Invoice[] = [
  {
    id: "USL/2026/0001",
    client: "Acme Corp Pvt Ltd",
    period: "01 Jan – 31 Jan 2026",
    amount: 15000,
    gst: 2700,
    total: 17700,
    status: "Paid",
    sent: "01 Jan 2026",
    paid: "09 Jan 2026",
    received: 17700,
    receivedDate: "09 Jan 2026",
    pending: 0,
    paidDate: "09 Jan 2026",
  },
  {
    id: "USL/2026/0002",
    client: "Acme Corp Pvt Ltd",
    period: "01 Feb – 28 Feb 2026",
    amount: 15000,
    gst: 2700,
    total: 17700,
    status: "Paid",
    sent: "01 Feb 2026",
    paid: "11 Feb 2026",
    received: 17700,
    receivedDate: "11 Feb 2026",
    pending: 0,
    paidDate: "11 Feb 2026",
  },
  {
    id: "USL/2026/0003",
    client: "Acme Corp Pvt Ltd",
    period: "01 Mar – 31 Mar 2026",
    amount: 15000,
    gst: 2700,
    total: 17700,
    status: "Paid",
    sent: "01 Mar 2026",
    paid: "12 Mar 2026",
    received: 17700,
    receivedDate: "12 Mar 2026",
    pending: 0,
    paidDate: "12 Mar 2026",
  },
  {
    id: "USL/2026/0004",
    client: "Acme Corp Pvt Ltd",
    period: "01 Apr – 30 Apr 2026",
    amount: 15000,
    gst: 2700,
    total: 17700,
    status: "Sent",
    sent: "01 Apr 2026",
    paid: null,
    received: 0,
    receivedDate: null,
    pending: 17700,
    paidDate: null,
  },
  {
    id: "USL/2026/0005",
    client: "Acme Corp Pvt Ltd",
    period: "01 May – 31 May 2026",
    amount: 15000,
    gst: 2700,
    total: 17700,
    status: "Overdue",
    sent: "01 May 2026",
    paid: null,
    received: 0,
    receivedDate: null,
    pending: 17700,
    paidDate: null,
  },
  {
    id: "USL/2026/0006",
    client: "Acme Corp Pvt Ltd",
    period: "01 Jun – 30 Jun 2026",
    amount: 15000,
    gst: 2700,
    total: 17700,
    status: "Pending",
    sent: null,
    paid: null,
    received: 0,
    receivedDate: null,
    pending: 17700,
    paidDate: null,
  },
  {
    id: "USL/2026/0007",
    client: "Acme Corp Pvt Ltd",
    period: "01 Jul – 31 Jul 2026",
    amount: 15000,
    gst: 2700,
    total: 17700,
    status: "Draft",
    sent: null,
    paid: null,
    received: 0,
    receivedDate: null,
    pending: 17700,
    paidDate: null,
  },
  {
    id: "USL/2026/0008",
    client: "Acme Corp Pvt Ltd",
    period: "01 Aug – 31 Aug 2026",
    amount: 15000,
    gst: 2700,
    total: 17700,
    status: "On Hold",
    sent: null,
    paid: null,
    received: 0,
    receivedDate: null,
    pending: 17700,
    paidDate: null,
  },
];

export const BILLING_CONFIGS: BillingConfig[] = [
  {
    project: "Acme ERP",
    client: "Acme Corp Pvt Ltd",
    type: "License Renewal",
    frequency: "Half-Yearly",
    amount: 15000,
    cgstRate: "9%",
    sgstRate: "9%",
    igstRate: "—",
    status: "Active",
  },
  {
    project: "Beta CRM",
    client: "Beta Solutions Ltd",
    type: "Subscription",
    frequency: "Monthly",
    amount: 8500,
    cgstRate: "9%",
    sgstRate: "9%",
    igstRate: "—",
    status: "Active",
  },
  {
    project: "Gamma Portal",
    client: "Gamma Infotech",
    type: "Maintenance",
    frequency: "Quarterly",
    amount: 22000,
    cgstRate: "9%",
    sgstRate: "9%",
    igstRate: "—",
    status: "Draft",
  },
  {
    project: "Delta Cloud",
    client: "Delta Systems",
    type: "Subscription",
    frequency: "Yearly",
    amount: 95000,
    cgstRate: "9%",
    sgstRate: "9%",
    igstRate: "—",
    status: "On Hold",
  },
];
